import 'pages/products/products/products-list-select-modal.tag'
riot.tag2('label-edit', '  <loader if="{loader}"></loader>\n  <div>\n    <div class="btn-group"><a class="btn btn-default" href="#products/labels"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новая метка товара\' : item.name || \'Редактирование метки\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#label-edit-main">Информация о метки</a></li>\n      <li><a data-toggle="tab" href="#label-edit-products">Товары</a></li>\n    </ul>\n    <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="label-edit-main">\n          <div class="form-group {has-error: error.name}">\n            <div class="row">\n              <div class="col-md-2">\n                <div class="form-group">\n                  <label class="control-label">Иконка</label>\n                  <div class="well well-sm">\n                    <image-select name="imageFile" alt="0" section="labels" size="64" value="{item.imageFile}"></image-select>\n                  </div>\n                </div>\n              </div>\n              <div class="col-md-10">\n                <div class="form-group">\n                  <label class="control-label">Название метки</label>\n                  <input class="form-control" name="name" type="text" value="{item.name}">\n                  <div class="help-block">{error.name}</div>\n                </div>\n                <div class="form-group">\n                  <label class="control-label">Код</label>\n                  <input class="form-control" name="code" type="text" value="{item.code}">\n                  <div class="help-block">{error.code}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="label-edit-products">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="products" add="{addProducts}" cols="{productsCols}" rows="{item.products}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');
self.item = {};

self.productsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.rules = {
    name: 'empty',
    code: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.submit = function () {
    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'ProductLabel',
            method: 'Save',
            data: self.item,
            success: function success(response) {
                self.item = response;
                popups.create({ title: 'Успех!', text: 'Метка для товара сохранена!', style: 'popup-success' });
                if (self.isNew) riot.route('products/labels/' + self.item.id);
                observable.trigger('products-labels-reload');
                self.update();
            }
        });
    }
};

self.addProducts = function () {
    modals.create('products-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            self.item.products = self.item.products || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.item.products.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) {
                    self.item.products.push(item);
                }
            });

            self.update();
            this.modalHide();
        }
    });
};

self.reload = function () {
    return observable.trigger('labels-edit', self.item.id);
};

observable.on('label-new', function () {
    self.error = false;
    self.item = {};
    self.isNew = true;
    self.update();
});

observable.on('labels-edit', function (id) {
    self.error = false;
    self.loader = true;
    self.item = {};
    self.isNew = false;
    self.update();

    API.request({
        object: 'ProductLabel',
        method: 'Info',
        data: { id: id },
        success: function success(response) {
            self.item = response;
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/labels/label-edit.tag